import { TmsField } from './tms-field.model';

export enum VendorTypeCategoryNames {
  ACCOMODATION = 'Accommodation',
  FOOD_AND_BEVERAGE = 'Food & Beverage',
  TRANSPORTATION = 'Transportation',
  ACTIVITIES = 'Activities',
  EVENTS_AND_CONFERENCES = 'Events & Conferences',
  SPECIAL = 'Special',
  OTHER = 'Other'
}

export const VendorTypeCategoryNamesOrder = [
  VendorTypeCategoryNames.SPECIAL,
  VendorTypeCategoryNames.ACCOMODATION,
  VendorTypeCategoryNames.FOOD_AND_BEVERAGE,
  VendorTypeCategoryNames.TRANSPORTATION,
  VendorTypeCategoryNames.ACTIVITIES,
  VendorTypeCategoryNames.EVENTS_AND_CONFERENCES,
];

export const VendorTypeCategory = [
  VendorTypeCategoryNames.SPECIAL,
  VendorTypeCategoryNames.ACCOMODATION,
  VendorTypeCategoryNames.FOOD_AND_BEVERAGE,
  VendorTypeCategoryNames.TRANSPORTATION,
  VendorTypeCategoryNames.ACTIVITIES,
  VendorTypeCategoryNames.EVENTS_AND_CONFERENCES,
  VendorTypeCategoryNames.OTHER,
];
export interface VendorType {
  id: string;
  category: TmsField;
  name: string;
}
